/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITenant } from 'app/shared/model/tenant.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface ITenantAccess {
  id?: string;
  uhid?: string | null;
  active?: boolean | null;
  revoked?: boolean | null;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  cursor?: number;
  comboUser?: ITenant;
  glucoUser?: IGlucoUser;
}

export const defaultValue: Readonly<ITenantAccess> = {
  active: false,
  revoked: false,
};
